'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PageLoaderMain = require('./PageLoaderMain');

var _PageLoaderMain2 = _interopRequireDefault(_PageLoaderMain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageLoader = function PageLoader(props) {
    return _react2.default.createElement(
        'div',
        { className: 'PageLoader Workspace' },
        _react2.default.createElement(
            'header',
            { className: 'AppHeader' },
            _react2.default.createElement('div', { className: 'header-section header-tools' }),
            _react2.default.createElement('div', { className: 'header-section CurrentBoardHeader' })
        ),
        _react2.default.createElement(_PageLoaderMain2.default, props)
    );
};

PageLoader.propTypes = {
    showQuote: _propTypes2.default.bool
};

exports.default = PageLoader;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/loaders/PageLoader.js
// module id = 708
// module chunks = 0